import axios from 'axios';
import { apiGateway } from 'src/config';
import { getBearerToken } from 'src/utils/getBearerToken';
import { EnqueteAnswerCompliaEntity, FileType } from '../store/enqueteAnswerSlice';

/**
 *
 * ファイルスライスツール
 * @param file
 * @returns
 */
export const useS3FileUpload = () => {
  const multipartUpload = async (fileInfo: FileType, params: EnqueteAnswerCompliaEntity, id: string) => {
    if (fileInfo.file) {
      const token = await getBearerToken();
      const createChunks = (file: File, chunkSize = 10 * 1024 * 1024): Blob[] => {
        const chunks: Blob[] = [];
        let start = 0;
        while (start < file.size) {
          chunks.push(file.slice(start, start + chunkSize));
          start += chunkSize;
        }
        if (chunks.length === 0 && file.size === 0) {
          chunks.push(new Blob([]));
        }
        return chunks;
      };

      // マルチパートアップロードの作成リクエスト
      const createRes = await axios.post(
        apiGateway + '/enquete-answer-input/complia-file-create',
        JSON.stringify({
          filename: fileInfo.fileName,
          key: `${params.surveyDetailId}/${id}/${fileInfo.objectKeyName}`,
          type: fileInfo.file.type,
          respondentTargetId: params.respondentTargetId,
        }),
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
          timeout: 60000,
        },
      );
      // const createRes = await fetch(apiGateway + '/enquete-answer-input/complia-file-create', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ filename: fileInfo.fileName, key: fileInfo.key, type: fileInfo.file.type }),
      // }).then((r) => r.json());

      const { uploadId, key } = createRes.data;

      // スライス
      const chunks = createChunks(fileInfo.file);

      // 各パートをアップロード
      const uploadedParts: { ETag: string; PartNumber: number }[] = [];
      const concurrency = 5; // 同時実行数

      try {
        for (let i = 0; i < chunks.length; i += concurrency) {
          const batch = chunks.slice(i, i + concurrency);

          const results = await Promise.all(
            batch.map(async (chunk, index) => {
              const partNumber = i + index + 1;

              // 署名済みURLを取得
              const url = await axios.post(
                apiGateway + '/enquete-answer-input/complia-file-part-url',
                JSON.stringify({ key, uploadId, partNumber, respondentTargetId: params.respondentTargetId }),
                {
                  headers: { Authorization: token, 'Content-Type': 'application/json' },
                  timeout: 60000,
                },
              );

              // チャンクをアップロード
              const res = await fetch(url.data.url, { method: 'PUT', body: chunk });

              // ETagを返す
              return { ETag: res.headers.get('ETag')!, PartNumber: partNumber };
            }),
          );

          uploadedParts.push(...results);
        }
      } catch (error) {
        // アップロード中止
        await axios.post(apiGateway + '/enquete-answer-input/complia-file-bort', JSON.stringify({ key, uploadId }), {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
          timeout: 60000,
        });
        throw error;
      }

      // アップロード完了
      await axios.post(apiGateway + '/enquete-answer-input/complia-file-complete', JSON.stringify({ key, uploadId, parts: uploadedParts }), {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
        timeout: 60000,
      });

      return key; // S3 ファイルパス
    }
  };
  return { multipartUpload };
};
